
<div class="input-group icon-inline">
  <input class="form-control" #input [(ngModel)]="_model" type="search" [placeholder]="text" data-test-qa="filterInput" id="filterbox-search" autocomplete="off">
  <div class="input-group-addon" *ngIf="button">
    <ng-content></ng-content>
  </div>
  <div class="icon"><i class="far fa-search"></i></div>
</div>